import React from "react";

/**
 * TextBreaker Component
 * Converts <br/> or <br> inside text into real React line breaks
 *
 * Usage:
 * <TextBreaker text={data.title} />
 */

const TextBreaker = ({ text = "", className = "" }) => {
  const lines = text.split(/<br\s*\/?>/i);

  return (
    <span className={className}>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index !== lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );
};

export default TextBreaker;